import Vue from 'vue';
import store from '../store';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import GetStartedForm from '../components/Partners/Onboarding/GetStartedForm';
import PartnerPackages from '../components/Partners/Onboarding/Packages';
import PartnerPackageSingle from '../components/Partners/Onboarding/PackageSingle';
import InviteHousemateForm from '../components/forms/InviteHousematesForm.vue';
import SuccessForm from '../components/forms/SuccessForm';

Vue.use(BootstrapVue);
Vue.component('GetStartedForm', GetStartedForm);
Vue.component('PartnerPackages', PartnerPackages);
Vue.component('PartnerPackageSingle', PartnerPackageSingle);
Vue.component('InviteHousematesForm', InviteHousemateForm);
Vue.component('SuccessForm', SuccessForm);

const app = new Vue({
    el: '#app',
    store
});
